import { useQuery } from '@tanstack/react-query';
import { useUser } from '@/hooks/useUser';
import { queryFn } from './queryFn';

export const getQueryKey = (userId: string): [string, string | undefined] => [
  'NARRATIVE_PERMISSION',
  userId,
];

const defaultNarrativePermissions = {
  narrativePermissions: {
    canAddAnnouncement: false,
    canDeleteAnnouncement: false,
    canUpdateAnnouncement: false,
  },
  userVotedNarratives: [],
};

const useNarrativePermission = () => {
  const { data: user } = useUser();
  const { data = defaultNarrativePermissions } = useQuery({
    queryKey: getQueryKey(user.id),
    queryFn,
    enabled: user.loggedIn && typeof user !== 'undefined',
    staleTime: 3600000,
    retry: 1,
  });

  return data;
};

export default useNarrativePermission;
